import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AppDataService {
  baseUrl = environment.baseUrl;
  baseChirpUrl = environment.baseChirpUrl;
  baseGoatUrl = environment.baseGoatUrl;
  baseHref = environment.baseHref;
  appConfig: any;
  username: string;
  isRequestInProgress: boolean;
  showProspective: boolean;
  userId: number;
  // fixedToolbar = false;
  promotionPodType: Observable<string>;
  userFullName: string;
  loggedIn = false;
  appReady = false;
  token: string;
  // profile: Profile;
  restHeaders: any = {};
  requiresPasswordReset: boolean = false;
  user: any;
  orgId: number;
  externalOrgCode: string;
  orgUsername: string;
  organizationLogoUrl: string;
  segmentId: number;
  singleOrgUser: string;

  isCSR: boolean;
  isCSRManager: boolean;
  isLiveAgent: boolean;
  isLiveAgentManager: boolean;
  isPartner: boolean;
  isAccountManager: boolean;
  isProgramManager: boolean;
  isAdmin: boolean;
  useAllowlist: boolean;
  allowSurveyExport: any;

  constructor(private injector: Injector, private toastr: ToastrService) {
    this.getAppConfig();
  }

  getAppConfig = (): void => {
    fetch('./assets/app-config.json').then((resp: any) => {
      resp.json().then((data: any) => {
        this.appConfig = resp;
      });
    });
  };

  public get router(): Router {
    return this.injector.get(Router);
  }

  // TODO: implement properly
  public onLogout(wasUserInitiated: boolean): void {
    this.loggedIn = false;
    this.appReady = false;
    this.token = null;
    this.restHeaders = {};
    if (wasUserInitiated) {
      this.toastr.info('You have been logged out. Thanks for visiting!');
    } else {
      this.toastr.warning('Your session is expired. Please log in again to continue.');
    }
  }

  public checkPermission(permission: string): boolean {
    const token: string = localStorage.getItem('token');
    let valid = false;

    if (token !== null && token !== 'null') {
      const jwth = new JwtHelperService();
      if (jwth.isTokenExpired(token)) {
        console.log('Found expired token: ' + token);
        this.router.navigate(['/logged-out']);
        return;
      } else {
        const dt = jwth.decodeToken(token);
        const roles = [
          'LIVE_AGENT',
          'LIVE_AGENT_MANAGER',
          'CSR',
          'PARTNER',
          'CSR_MANAGER',
          'ACCOUNT_MANAGER',
          'PROGRAM_MANAGER',
          'ADMIN',
        ];
        const requiredPermission = roles.indexOf(permission);
        dt.roles.forEach((role) => {
          if (roles.indexOf(role) >= requiredPermission) {
            valid = true;
          }
        });
        this.requiresPasswordReset = dt.requiresPasswordReset;
        if (dt.requiresPasswordReset) {
          this.router.navigate(['new-password']);
        }
      }
    }
    return valid;
  }
}
